import axios from 'axios';

// Create a separate axios instance for the analyst service
const analystApi = axios.create({
  baseURL: process.env.REACT_APP_ANALYST_API_URL || 'http://localhost:8001',
  timeout: 180000, // 3 minutes timeout for hybrid analysis (technical + fundamental)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add authentication token
analystApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
analystApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Analyst API Error:', error);
    
    // Handle specific error cases
    if (error.response) {
      // Server responded with error status
      const { status } = error.response;
      
      switch (status) {
        case 401:
          console.error('Analyst API: Unauthorized - Please log in');
          break;
        case 403:
          console.error('Analyst API: Forbidden - EXPERT subscription required');
          break;
        case 404:
          console.error('Analyst API: Endpoint not found');
          break;
        case 500:
          console.error('Analyst API: Internal server error');
          break;
        default:
          console.error(`Analyst API: HTTP ${status} error`);
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error('Analyst API: No response received - service may be down');
    } else {
      // Something else happened
      console.error('Analyst API: Request setup error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default analystApi;
